import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { BRAND } from "@/lib/content";
import { EligibilityButton } from "@/components/landing/EligibilityButton";

export const AnnouncementBar = () => (
  <div
    className="relative z-40 flex items-center justify-center gap-2 border-b border-surfaceline bg-ink2 px-4 py-2.5 text-center text-[0.78rem] font-semibold text-offwhite sm:text-sm"
    data-testid="announcement-bar"
  >
    <span className="h-1.5 w-1.5 rounded-full bg-em2" />
    <span>
      New Offline Batch Starting Soon in Ahmedabad ·{" "}
      <span className="text-em2">Limited Seats, Personal Mentorship</span>
    </span>
  </div>
);

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`sticky top-0 z-40 transition-colors duration-300 ${
        scrolled ? "border-b border-surfaceline bg-ink/80 backdrop-blur-xl" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-8 sm:py-4">
        <a href="/" className="flex items-center gap-2.5" data-testid="navbar-logo">
          <img
            src={BRAND.logo}
            alt="BullsEdge Academy"
            className="h-9 w-9 rounded-lg object-contain ring-1 ring-surfaceline sm:h-10 sm:w-10"
          />
          <div className="leading-none">
            <span className="block font-display text-lg font-bold tracking-tight text-offwhite sm:text-xl">
              BullsEdge Academy
            </span>
            <span className="mt-0.5 flex items-center gap-1 text-[0.62rem] font-semibold uppercase tracking-[0.18em] text-gold">
              <MapPin size={10} /> Ahmedabad Center
            </span>
          </div>
        </a>
        <div className="hidden sm:block">
          <EligibilityButton size="sm" testId="navbar-inquire-btn" />
        </div>
      </div>
    </motion.nav>
  );
};
